import { styled } from '@linaria/react';
import { colors, fonts, semantic, space } from '../../theme/tokens';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const OptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const SelectionCount = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const OptionCard = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${space[4]};
  border: 1px solid ${semantic.border.default};
  border-radius: 12px;
  background: ${colors.white};
  cursor: pointer;
  font-family: ${fonts.body};
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  min-height: 88px;

  &:hover {
    border-color: ${semantic.text.secondary};
  }

  &[data-selected='true'] {
    border-width: 2px;
    border-color: ${semantic.border.selected};
    padding: calc(${space[4]} - 1px);
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &[data-disabled='true']:hover {
    border-color: ${semantic.border.default};
  }
`;

export const OptionLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 0;
`;

export const OptionImage = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
`;

export const OptionImagePlaceholder = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 6px;
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};
`;

export const TimeslotPanel = styled.div`
  background: ${semantic.bg.surfaceSubtle};
  border-radius: 12px;
  padding: ${space[4]};
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const TimeslotHeading = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const SectionError = styled.div``;

export const TimeslotError = styled.div``;
